import Icon from "../../a-atoms/icons/Icon";
import style from "./Button.module.css";

const Button = (props) => {
  return (
    <button
      onClick={props.onClick}
      disabled={props.disabled}
      className={`${style.button} ${
        props.variants ? props.variants.map((i) => style[i]).join(" ") : null
      } ${props.preIcon ? style.preIcon : null} ${
        props.preIcon ? (!props.children ? style.iconOnly : null) : null
      } ${props.disabled ? style.disabled : null}`}
    >
      {props.preIcon ? <Icon variants={["inheritColor"]}>{props.preIcon}</Icon> : null}
      {props.children}
      {props.trailingIcon ? <Icon variants={["inheritColor"]}>{props.trailingIcon}</Icon> : null}
    </button>
  );
};

export default Button;
